import { Flex } from "../Flex/Flex";
import type { FlexProps } from "../Flex/types";

function HStack(props: FlexProps) {
    return <Flex direction="row" {...props} />;
}

export { HStack };
